import { useEffect, useState } from "react";
import { api, fmtDateTime } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const load = () => api.get("/notifications").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { await api.post(`/notifications/${id}/read`); load(); };
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div data-testid="notifications-page">
      <PageHeader title="Notifications" description="System alerts, approvals & task updates." action={
        <Button variant="outline" onClick={markAll} data-testid="notifications-mark-all">Mark all read</Button>
      } />
      <div className="space-y-2">
        {items.length === 0 && <Card className="p-10 text-center text-sm text-slate-500">No notifications.</Card>}
        {items.map((n) => (
          <Card key={n.id} className={`p-4 cursor-pointer ${n.read ? "opacity-70" : ""}`} onClick={() => { markRead(n.id); if (n.link) navigate(n.link); }}>
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="text-xs uppercase tracking-wider text-slate-500">{(n.type || "").replace(/_/g, " ")}</div>
                <div className="text-sm font-medium text-slate-900">{n.title}</div>
                <div className="text-sm text-slate-600">{n.message}</div>
              </div>
              <div className="text-xs text-slate-400 shrink-0">{fmtDateTime(n.created_at)}</div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
